import { render, staticRenderFns } from "./ContentAuditView.vue?vue&type=template&id=785b8efa&scoped=true"
import script from "./ContentAuditView.vue?vue&type=script&lang=js"
export * from "./ContentAuditView.vue?vue&type=script&lang=js"
import style0 from "./ContentAuditView.vue?vue&type=style&index=0&id=785b8efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785b8efa",
  null
  
)

export default component.exports